import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ListItem, Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useMemo } from 'react'
import type { To } from 'react-router'
import { useNavigate } from 'react-router'

import { COLORS, ICONS, unit } from '@hcr/ui'
import { isNotUndefined } from '@hcr/utils'

import { useLastPath } from '../../../../../contexts'
import { Path } from '../../../../../models'
import { isServicesPath, to } from '../../../../../utils'
import { BookingListDescription } from '../../../../booking/booking/common'
import type { BookingListPreviewProps } from '../../../../common'

export const BookingListPreview: FC<BookingListPreviewProps> = ({
  dateRange,
  destinationId,
  destinationName,
  isActive,
  onClick,
  totalTickets,
}) => {
  const lastPath = useLastPath()
  const navigate = useNavigate()

  const backNavigationPath = useMemo((): To => {
    if (isNotUndefined(destinationId) && isServicesPath(lastPath.root)) {
      return to([Path.Services, { destinationId }])
    }

    return lastPath.root
  }, [destinationId, lastPath.root])

  return (
    <ListItem disablePadding>
      <BookingListLink
        sx={{
          backgroundColor: isActive ? COLORS.burgundi[500] : COLORS.vaalea['60%'],
          color: isActive ? COLORS.white : COLORS.black,
        }}
        onClick={() => {
          onClick()
          void navigate(backNavigationPath)
        }}
      >
        <Stack>
          <Typography component='h2' color={isActive ? 'inherit' : COLORS.burgundi[500]} variant='headlineS'>
            {destinationName}
          </Typography>
          <BookingListDescription dateRange={dateRange} totalTickets={totalTickets} isActive={isActive} />
        </Stack>
        <FontAwesomeIcon icon={ICONS.farChevronRight} fontSize={unit(5.5)} />
      </BookingListLink>
    </ListItem>
  )
}

const BookingListLink = styled(Button)`
  display: flex;
  justify-content: space-between;
  gap: ${unit(4)};
  text-align: left;
  border-top: thin solid ${COLORS.vaalea[600]};
  padding: ${unit(4)} ${unit(8)} ${unit(5)} ${unit(7)};
  cursor: pointer;
`
